import { render, staticRenderFns } from "./MiniPaper.vue?vue&type=template&id=76e95759&scoped=true&"
import script from "./MiniPaper.vue?vue&type=script&lang=js&"
export * from "./MiniPaper.vue?vue&type=script&lang=js&"
import style0 from "./miniPaper.scss?vue&type=style&index=0&id=76e95759&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e95759",
  null
  
)

export default component.exports